// Blank pile cable form for manual entry (no pre-populated cable_id).
// For the pre-populated form (from PileDashboard's cable "Settings" button), see cable.tsx.
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { PileCableForm } from '@amber-ui/core';

function PileCablesRoute() {
  const { pile } = useSearch({ strict: false }) as { pile?: string };
  const pile_id = pile || null;

  if (!pile_id) return null;

  return <PileCableForm pile_id={pile_id} />;
}

export const Route = createFileRoute('/_auth/_pile/pile/cables')({
  component: PileCablesRoute,
});
